// extracted by mini-css-extract-plugin
module.exports = {"loadingWrap":"loadingWrap--8mnhj","hide":"hide--3P1-h","loadingBox":"loadingBox--jvszl","title":"title--vVRax","sub":"sub--1PJXM","buttons":"buttons--QM_HV"};